module.exports = __webpack_public_path__ + "img/39.d5b4c5f7.png";